import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

export const ASSET_NAME = 'terms-and-conditions';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { [ASSET_NAME]: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
